import Vue from 'vue';
import Slsm from './index.vue';

const SlsmDialog = Vue.extend(Slsm);

Slsm.install = function(data) {
  let instance = new SlsmDialog({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.dialogVisible = true;
    // show 和弹窗组件里的show对应，用于控制显隐
  });
};

export default Slsm;
